// =====================================
//
//   All Product Controller
//   Author: Gray
//   createtime: 2016 / 08 / 31
//
// =====================================

window.InifECMobileApp.controller("AllProductController", ['$scope', '$state', '$timeout', '$rootScope', '$stateParams', 'ProductService', '$InifECGA', 'UserService', '$WebTitle', '$ProductFormatService',
	function($scope, $state, $timeout, $rootScope, $stateParams, ProductService, $InifECGA, UserService, $WebTitle, $ProductFormatService) {
        
        var getProductClassListLite = function(mainPdtClass, pdtClass) {

            $scope.isLoading = true;

            ProductService.getProductClassListLite().then(function(result) {

                if(result) {

                    $scope.pdtClassList = $ProductFormatService.getPdtClassList('ALL_PRODUCT');

                    if(!$scope.pdtClassList || $scope.pdtClassList.length == 0) {
                        var _result = shallowCopy(result);
                        
                        $scope.pdtClassList = $ProductFormatService.formatAllProductPdtClassList(_result);
                    }

                    if(pdtClass) {
                        var findClass = result.pdtClass_ProductMap[pdtClass];

                        if(findClass) {
                            pdtClass = findClass.urlParamName;
                        }
                    }

                    getProductClassListLiteSuccess(mainPdtClass, pdtClass);
                }

                $scope.isLoading = false;
            }, function(error) {
                $scope.isLoading = false;
                $scope.isError = true;
            });
        }

        var getProductClassListLiteSuccess = function(mainPdtClass, pdtClass) {

            if(mainPdtClass || pdtClass) {
                filterPdtClassListByClass(mainPdtClass, pdtClass);
            }

            var ga_info = {
                mrscid: (UserService.user && UserService.user.mrscid) ? UserService.user.mrscid : 'visitor',
            }

            $InifECGA.eventTrack('allproducts', 'view', ga_info.mrscid);
        }

        var onMainPdtClassClick = function(mainPdtClass, pdtClass, isReplace) {

            if(!mainPdtClass) {
                $scope.currentMainPdtClass = undefined;
                $scope.currentPdtClass = undefined;

                if(pdtClass) {
                    return;
                }

                $state.go(window.STATES.ALL_PRODUCT, {
                    mainPdtClass: '',
                },{
                    // reload: false,
                    location: isReplace ? "replace" : true,
                })

                $WebTitle.changeWebTitle(window.STATES.ALL_PRODUCT);

                return;
            }

            if($scope.currentMainPdtClass && $scope.currentMainPdtClass.mainPdtClassID == mainPdtClass.mainPdtClassID) {
                return;
            }

            $scope.currentMainPdtClass = mainPdtClass;
            $scope.currentPdtClass = undefined;

            if(pdtClass) {
                return;
            }

            $state.go(window.STATES.ALL_PRODUCT, {
                mainPdtClass: mainPdtClass.mainPdtClassID,
            },{
                // reload: false,
                location: isReplace ? "replace" : true,
            });

            if(mainPdtClass.seoTitle) {
                $WebTitle.setWebTitle(mainPdtClass.seoTitle);
            } else {
                $WebTitle.changeWebTitle(window.STATES.ALL_PRODUCT);
            }
        }

        var onPdtClassClick = function(pdtClass, isReplace) {

            $scope.currentPdtClass = pdtClass;

            if(pdtClass) {

                $state.go(window.STATES.PRODUCT_LIST, {
                    class: pdtClass.urlParamName,
                },{
                    reload: false,
                    location: isReplace ? "replace" : true,
                });

                $WebTitle.setPdtClassWebTitle(pdtClass);
            } else {

                $state.go(window.STATES.ALL_PRODUCT, {
                    mainPdtClass: $scope.currentMainPdtClass.mainPdtClassID,
                },{
                    reload: false,
                    location: isReplace ? "replace" : true,
                });

                if($scope.currentMainPdtClass.seoTitle) {
                    $WebTitle.setWebTitle($scope.currentMainPdtClass.seoTitle);
                } else {
                    $WebTitle.changeWebTitle(window.STATES.ALL_PRODUCT);
                }
            }
        }

        var getProductHomeCoverImage = function(product) {

            if(!product) {
                return "about:blank";
            }

            if(product.homeCover) {
                return product.homeCover;
            } else if (Array.isArray(product.covers) && product.covers.length > 0){
                return product.covers[0];
            } else {
                return "about:blank";
            }
        }

        var getProductCoverImage = function(product) {

            if(!product || !Array.isArray(product.covers) || product.covers.length == 0){
                return "about:blank";
            }

            return product.covers[0];
        }

        var filterPdtClassListByClass = function(currentMainPdtClass, currentPdtClassUrlParam) {

            if(currentMainPdtClass && currentPdtClassUrlParam) {
                for(var i = 0; i < $scope.pdtClassList.length; i++) {
                    var mainPdtClass = $scope.pdtClassList[i];

                    if(currentMainPdtClass == mainPdtClass.mainPdtClassID) {
                        for(var j = 0; j < mainPdtClass.pdtClasses.length; j++) {
                            var pdtClass = mainPdtClass.pdtClasses[j];

                            if(currentPdtClassUrlParam == pdtClass.urlParamName) {
                                onMainPdtClassClick(mainPdtClass, pdtClass, true);
                                onPdtClassClick(pdtClass, true);
                                return;
                            }
                        }
                    }
                }
            } else if(currentPdtClassUrlParam) {
                for(var i = 0; i < $scope.pdtClassList.length; i++) {
                    var mainPdtClass = $scope.pdtClassList[i];

                    for(var j = 0; j < mainPdtClass.pdtClasses.length; j++) {
                        var pdtClass = mainPdtClass.pdtClasses[j];

                        if(currentPdtClassUrlParam == pdtClass.urlParamName) {
                            onMainPdtClassClick(mainPdtClass, pdtClass, true);
                            onPdtClassClick(pdtClass, true);
                            return;
                        }
                    }
                }
            } else if(currentMainPdtClass) {
                for(var i = 0; i < $scope.pdtClassList.length; i++) {
                    var mainPdtClass = $scope.pdtClassList[i];

                    if(currentMainPdtClass == mainPdtClass.mainPdtClassID) {
                        onMainPdtClassClick(mainPdtClass, undefined, true);
                        return;
                    }
                }
            }
        }

        // ------------------------------
        // [SCOPE] 取得商品列表後面需補的空白class
        // ------------------------------
        var getEmptyClass = function(products) {
            
            var emptyClass = 'empty-item-0';

            if(!Array.isArray(products) || products.length === 0) {
                return emptyClass;
            }

            var size = products.length;
            var remainder = size % 4;

            if(remainder == 0) {
                return emptyClass;
            }

            var emptyCount = 4 - remainder;

            emptyClass = 'empty-item-' + emptyCount;

            if(size < 4) {
                emptyClass += ' no-border-top';
            }

            return emptyClass;
        }

        var init = function(fromParams) {

            var mainPdtClass

            if($scope.state == window.STATES.ALL_PRODUCT) {
                mainPdtClass = $stateParams.mainPdtClass;
                if(!mainPdtClass) {
                    $state.go(window.STATES.HOME, {}, {notify: false, location: "replace"})
                }
            } else {
                mainPdtClass = $stateParams.mainPdtClass || fromParams.mainPdtClass;
            }

            var pdtClass = $stateParams.class;
            getProductClassListLite(mainPdtClass, pdtClass);
        }

        //==========================
        //  Events
        //==========================

        $scope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {

            $scope.state = $state.current.name;

            if($scope.state == window.STATES.ALL_PRODUCT || $scope.state == window.STATES.PRODUCT_LIST) {
                init(fromParams);
            }
        });

        //==========================
        //  Members
        //==========================
        $scope.isLoading = false;
        $scope.isError = false;
        $scope.pdtClassList = [];
        $scope.state = undefined;
        $scope.currentMainPdtClass;
        $scope.currentPdtClass;
       
        //==========================
        //  Methods
        //==========================
        $scope.onMainPdtClassClick = onMainPdtClassClick;
        $scope.onPdtClassClick = onPdtClassClick;
        $scope.getProductHomeCoverImage = getProductHomeCoverImage;
        $scope.getProductCoverImage = getProductCoverImage;
        $scope.getEmptyClass = getEmptyClass; // 取得商品列表後面需補的空白class

        //==========================
        //  Init
        //==========================
        // init();
	}
]);